import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import { updateContact } from "../../reducers/websiteReducer/websiteReducer";

const DeleteLenderModal = ({ agent, lender, onClose }) => {
  const person = agent || lender;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const name = agent ? "Website Profile" : "Lender";

  return (
    <Modal
      show={Boolean(person)}
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title={agent ? "Remove Website Profile" : "Remove Lender"} closeButton={!loading} />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
        <Typography variant="body-m">
          This {name} will no longer be featured on your {agent ? "team" : "listing"} pages but will remain as
          a contact in your CRM. Are you sure you want to remove the {name}?
        </Typography>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button disabled={loading} size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          isLoading={loading}
          size="medium"
          schema="warning"
          onClick={() => {
            setLoading(true);
            dispatch(
              updateContact({
                id: person.id,
                userUuid: person.userUuid,
                ...(lender && { websiteRosterPreferredLender: null }),
                ...(agent && { websiteRosterPersonAgent: null }),
              }),
            ).then(({ meta }) => {
              setLoading(false);
              onClose(meta.requestStatus === "fulfilled");
            });
          }}
        >
          Yes, Remove
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteLenderModal.propTypes = {
  agent: PropTypes.shape(),
  lender: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
};

DeleteLenderModal.defaultProps = {
  agent: null,
  lender: null,
};

export default DeleteLenderModal;
